import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { authGuard } from './shared/guards/auth/auth.guard';


export const routes: Routes = [
  {
    path: '', component: LayoutComponent,
    children: [
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile.component').then((c) => c.ProfileComponent),
        canActivate: [authGuard],
        data: { page_name: 'profile', origin: 'pf' }
      },
      {
        path: 'donations',
        loadComponent: () => import('./pages/my-donations/my-donations.component').then((c) => c.MyDonationsComponent),
        canActivate: [authGuard],
        data: { page_name: 'donations', origin: 'dn' }
      },
      {
        path: 'thankyou',
        loadComponent: () => import('./pages/thankyou/thankyou.component').then((c) => c.ThankyouComponent),
        data: { page_name: 'thank_you', origin: 'ty' }
      },
      {
        path: 'stories/:tag',
        loadComponent: () => import('./pages/story/story.component').then((c) => c.StoryComponent),
        data: { page_name: 'stories', origin: 's' }
      },
      {
        path: 'updates/:tag',
        loadComponent: () => import('./pages/updates/updates.component').then((c) => c.UpdatesComponent),
        data: { page_name: 'updates', origin: 'up' }
      },
      {
        path: 'payment-route',
        loadComponent: () => import('./pages/payment-route/payment-route.component').then((c) => c.PaymentRouteComponent),
        data: { page_name: 'payment_redirect_page', origin: 'prp' }
      },
      {
        path: 'aboutus',
        loadComponent: () => import('./pages/aboutus/aboutus.component').then((c) => c.AboutusComponent),
        data: { page_name: 'aboutus', origin: 'au' }
      },
      {
        path: 'guarantee',
        loadComponent: () => import('./pages/guarantee/guarantee.component').then((c) => c.GuaranteeComponent),
        data: { page_name: 'guarantee', origin: 'gu' }
      },
      {
        path: 'signin',
        loadComponent: () => import('./core/signin-signup/signin-signup.component').then((c) => c.SigninSignupComponent),
        canActivate: [authGuard],
        data: { page_name: 'signin', origin: 'si' }
      },
      {
        path: 'sip/:cause',
        loadComponent: () => import('./pages/sip/sip.component').then((c) => c.SipComponent),
        data: { page_name: 'sip', origin: 'sip' }
      },
      {
        path: 'sip',
        loadComponent: () => import('./pages/sip/sip.component').then((c) => c.SipComponent),
        data: { page_name: 'sip', origin: 'sip' }
      },
      {
        path: 'icons',
        loadComponent: () => import('./pages/icons-list/icons-list.component').then((c) => c.IconsListComponent),
        data: { page_name: 'icons', origin: 'icons' }
      },
      // {
      //   path: 'success-stories',
      //   loadComponent: () => import('./pages/success-stories/success-stories.component').then((c) => c.SuccessStoriesComponent),
      //   data: { page_name: 'success_stories', origin: 'st' }
      // },
      // {
      //   path: 'success-story',
      //   loadComponent: () => import('./pages/success-stories/components/detail-success-story/detail-success-story.component').then((c) => c.DetailSuccessStoryComponent),
      //   data: { page_name: 'detail_success_story', origin: 'dst' }
      // },
      {
        path: '404',
        loadComponent: () => import('./pages/not-found/not-found.component').then((c) => c.NotFoundComponent),
        data: { page_name: 'page_not_found', origin: '404' }
      },
      {
        path: '',
        loadComponent: () => import('./pages/home/home.component').then((c) => c.HomeComponent),
        pathMatch: 'full',
        data: { page_name: 'home', origin: 'h' }
      },
      {
        path: '**',
        loadComponent: () => import('./pages/home/home.component').then((c) => c.HomeComponent),
        pathMatch: 'full',
        data: { page_name: 'home', origin: 'h', skipSEO: true }
      }
    ]
  }
];
